
// eslint-disable-next-line import/prefer-default-export
export const evidence = {
  data: () => ({
    evidenceLoading: false,
    evidenceData: '',
  }),
  watch: {
    evidenceData() {
      this.evidenceLoading = false;
    },
  },
  methods: {
    async downloadEvidence(disputeId) {
      this.evidenceLoading = true;
      this.evidenceData = await this.$store.dispatch('disputes/downloadEvidence', disputeId);
      return this.evidenceData;
    },

    async submitEvidence({ disputeId, comment }) {
      await this.$store.dispatch('disputes/submitEvidence', { disputeId, comment });
    },
  },
};
